<template>
  <div class="quantity">
    <CustomTitle :title="sumtitle" class="title" />
    <div class="chart">
      <Echart id="quantity" :options="options" height="100%" width="100%" />
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import * as echarts from 'echarts'
import CustomTitle from '@/components/CustomTitle'
import config from '@/js/config'
import { months } from 'moment'

export default {
  name: 'Quantity',
  data () {
    return {
      xData: [], // 横坐标
      yData: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'], // 人数数据
      taskDate: [],
      shiprate: [],
      myChartStyle: { float: 'left', width: '98%', height: '350px' }, // 图表样式
      salessum: [],
      pursum: [],
      charname: ['数量', '工时','达成率'],
      sumtitle: '',
      runpcs: 0,
      allrun: 0,
      timer: '',
      xname: '件',
      compid: -1,
      dept: '',
      options: {},
      requestTimer: null,
      retryTimer: null, // 重试延时器
      mounth:0,
      years:0,
      pcssumtitle:'',
      pgsumtitle:'',
      moneysumtitle:'',
      purpcssumtitle:'',
      purpgsumtitle:'',
      purmoneysumtitle:'',
      requestUrl:'',
      QATecIPQCFlag:0,
      dst:'',
      ded:'',
    }
  },
  components: {
    CustomTitle,
    Echart
  },
  watch: {},
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.getsum()
    this.starttime()
  },
  mounted () {
    this.requestTimer = setInterval(() => {
      this.getsum()
    }, config.refreshTime.quantity)
  },
  methods: {
    getsum () {
      clearTimeout(this.retryTimer)
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      this.QATecIPQCFlag = window.localStorage.getItem('QATecIPQCFlag')
      var paa = { compid: this.compid }
      var timeDate = new Date()
      var mounth = timeDate.getMonth() + 1
      // console.log('Salessum=' + this.dept)
      // this.requestUrl='http://localhost:8080/bsmtp/public'
      this.dept='WC';
      this.axios({
        method: 'post',
        //params: paa,
        //url: 'http://47.107.138.238/bsmtp/public/admin.php/Bigsreen/salessum'
        url: this.requestUrl+ '/admin.php/Bigsreen/PerformanceMana?compid='+this.compid+'&dept='+this.dept+'&dst='+this.dst+'&ded='+this.ded+'&QATecIPQCFlag='+this.QATecIPQCFlag
      })
        .then((Response) => {
          var clio = JSON.parse(Response.data)
          // console.log(this.requestUrl+ '/admin.php/Bigsreen/salessum?compid='+this.compid
          console.log(clio)
          this.salessum = clio
          this.xData = clio['姓名'] // 横坐标
          this.yData = clio['数量'] // 人数数据
          this.taskDate = clio['派工工时']
          this.shiprate = clio['绩效达成率']
         var ss=this.sum(clio['数量']);
         var sumtitle=""
         if(ss!="undefined" && ss!=undefined)
            sumtitle="(合计:"+ss+"件;工时 " +this.sum(clio['派工工时'])+"小时)"
         this.pcssumtitle=sumtitle;

          let jj=new Date(clio['日期'][0]);
          let year = timeDate.getFullYear()
          let mounth = timeDate.getMonth() + 1
          var yy=year+"年"+mounth+"月";
          this.years=yy;

          this.sumtitle =yy+ '工时统计。'+sumtitle
          this.xname = '小时'


          this.initEcharts()
        })
        .catch((error) => {
          console.log(error)
          this.retryTimer = setTimeout(() => {
            this.getsum()
          }, config.retryTime)
        })
    },
    sum(arr) {
       return eval(arr.join("+"));
     },
    starttime () {
      this.timer = setInterval(() => {
        if (this.allrun > 1440) {
          this.getsum()
          this.allrun = 0
        }
        let timeDate = new Date()
        let mounth = timeDate.getMonth() + 1

        var mm="今年";
        if( mounth<1)
           mm=""+(timeDate.getFullYear()-1)+"年";

         if (this.runpcs === 0) {

          var clio=this.salessum;
          this.xData = clio['姓名'] // 横坐标
           this.yData = clio['数量'] // 人数数据
           this.taskDate = clio['派工工时']
           this.shiprate = clio['绩效达成率']
          var ss=sum(clio['数量']);
           var sumtitle=""
           if(ss!="undefined" && ss!=undefined)
              sumtitle="(合计:"+ss+"件;工时 " +this.sum(clio['派工工时'])+"小时)"
           this.pcssumtitle=sumtitle;
          // var sumtitle="(合计:"+this.sum(clio['数量'])+"件;工时 " +this.sum(clio['派工工时'])+"小时)"
          this.pcssumtitle=sumtitle;

           let jj=new Date(clio['日期'][0]);
           let year = timeDate.getFullYear()
           let mounth = timeDate.getMonth() + 1
           var yy=year+"年"+mounth+"月";
           this.years=yy;
           this.charname=['数量', '工时','达成率'];

           this.sumtitle =yy+ '工时统计。'+sumtitle
           this.xname = '工时'
            this.runpcs=1;

        } else if (this.runpcs === 1) {
          var clio=this.salessum;
          this.xData = clio['姓名'] // 横坐标
           this.yData = clio['NG数量'] // 人数数据
           this.taskDate = clio['NG费用']
           this.shiprate = clio['NG率']
           var ss=sum(clio['NG数量']);
           var sumtitle=""
           if(ss!="undefined" && ss!=undefined)
             sumtitle="(合计不良:"+ss+"件;损失费用 " +this.sum(clio['NG费用'])+"元)"
           this.pcssumtitle=sumtitle;


           let jj=new Date(clio['日期'][0]);
           let year = timeDate.getFullYear()
           let mounth = timeDate.getMonth() + 1
           var yy=year+"年"+mounth+"月";
           this.charname=['异常数量', '异常工时','异常率'];
           this.years=yy;

           this.sumtitle =yy+ '品质异常统计'+sumtitle
           this.xname = '工时'
           this.runpcs=0;
        }
        this.initEcharts()
        this.allrun = this.allrun + 1
        // if(this.allrun==1)
        //   this.allrun=0;
      }, 10 * 1000)
    },
    initEcharts () {
      // const colors = ['#5470C6', '#91CC75', '#EE6666']
      this.options = {
        // color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        grid: {
          top: '20%',
          right: '50',
          bottom: '20',
          left: '60'
        },
        xAxis: {
          // type: "category",
          name:'姓名',
          data: this.xData,
          axisLine: { lineStyle: { color: 'rgba(230, 247, 255, 0.2)' } },
          splitLine: {
            lineStyle: {
              color: 'rgba(230, 247, 255, 0.2)',
              type: 'dashed'
            }
          },
          axisLabel: {
            textStyle: { color: '#68AECE', fontSize: '12' }
          },
          // text:'月份'
        },
        // 图例
        legend: {
          data: this.charname, // ["人数", "任务数"],
          top: '0%',
          itemHeight: 12, // 图例icon高度
          itemWidth: 12, // 图例icon宽度
          right: 0,
          width: '100%',
          textStyle: {
            color: '#FFFFFF'
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '单位:' + this.xname,
            nameTextStyle: {
              color: 'rgba(230, 247, 255, 0.7)'
            },
            axisTick: { show: false },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              fontSize: 12,
              color: '#68AECE' // "rgba(255,255,255,.6)",
            },
            axisLine: {
              show: false
            }
          },
          {
            type: 'value',
            name: this.charname[3], // '按时率',
            show: true,
            axisLabel: {
              show: true,
              fontSize: 12,
              formatter: '{value} %',
              color: '#68AECE'
            },
            axisTick: { show: false },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(230, 247, 255, 0.2)',
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            type: 'bar', // 形状为柱状图
            data: this.yData,
            name: this.charname[0], // "人数", // legend属性
            label: {
              // 柱状图上方文本标签，默认展示数值信息
              show: true,
              position: 'inside', // "top",
              rotate: 90,
              offset: [0, -22],
              color: '#BAE3E5',
              fontSize: 12,
              formatter: function (p) {
                let value = ''
                if (p.value > 0) {
                  value = p.value
                  if (value > 999) {
                    // 数值加千分号
                    let parts = value.toString().split('.')
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    value = parts.join('.')
                  }
                }
                return value
              }
            },
            barWidth: 17,
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#16853B'
                  },
                  {
                    offset: 1,
                    color: '#1DFA82'
                  }
                ])
              }
            }
          },
          {
            type: 'bar', // 形状为柱状图
            data: this.taskDate,
            name: this.charname[1], // legend属性
            label: {
              // 柱状图上方文本标签，默认展示数值信息
              show: true,
              position: 'inside', // "top",
              rotate: 90,
              offset: [0, -22],
              color: '#BAE3E5',
              fontSize: 12,
              formatter: function (p) {
                let value = ''
                if (p.value > 0) {
                  value = p.value
                  if (value > 999) {
                    // 数值加千分号
                    let parts = value.toString().split('.')
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    value = parts.join('.')
                  }
                }
                return value
              }
            },
            barWidth: 17,
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0C2B5C'
                  },
                  {
                    offset: 1,
                    color: '#077AEE'
                  }
                ])
              }
            }
          },
          {
            type: 'line', // 形状为柱状图
            data: this.shiprate,
            name: this.charname[2], // legend属性
            yAxisIndex: 1,
            label: {
              // 柱状图上方文本标签，默认展示数值信息
              show: false,
              position: 'top',
              align: 'center',
              color: 'wihte',
              // rotate: 90,
              barGap: 0.2,
              // value:{value}+'%'
              formatter: function (p) {
                let value = p.value + '%'
                return value
              }
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            itemStyle: {
              normal: {
                color: '#FFB700'
              }
            },
            smooth: false
          }
        ]
      }
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
  }
}
</script>

<style scoped lang="less">
.quantity {
  display: flex;
  flex-direction: column;
  .chart {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/workroomdp/components/Quantity.vue